import StatsConfig from "./StatsConfig";
import AuthService from "../auth/AuthService"
export default class StatsService {
  static ordersStats(app, restoId, dates, period, orderTypes, paymentMethod) {
    return new Promise(async (resolve, reject) => {
      try{

        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointOrdersStats;
        let body = JSON.stringify({ordRestoId:restoId, ordDates:dates, period:period, orderTypes:orderTypes, paymentMethod:paymentMethod}) 
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: body
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        console.log("ERROR ORDER STATS SERVICE", e)
        reject(e)
      }
    });
  }

  static menuStats(app, restoId, dates, period, unit, top, orderTypes, paymentMethod) {
    return new Promise(async (resolve, reject) => {
      try{

        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointMenuStats;
        let body = JSON.stringify({ordRestoId:restoId, period:period, unit:unit, top:top, dates:dates, orderTypes:orderTypes, paymentMethod:paymentMethod}) 
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: body
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        console.log("ERROR ORDER STATS SERVICE", e)
        reject(e)
      }
    });
  }

  static topClientStats(app, restoId, dates, period, orderTypes, paymentMethod) {
    return new Promise(async (resolve, reject) => {
      try{

        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointTopClientStats;
        let body = JSON.stringify({ordRestoId:restoId, ordDates:dates, period:period, orderTypes:orderTypes, paymentMethod:paymentMethod}) 
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: body
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        console.log("ERROR ORDER STATS SERVICE", e)
        reject(e)
      }
    });
  }
  
  static liqStats(app, restoId, dates, month, isDetail) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointLiqResumeStats;
        if(isDetail){
          endpoint = StatsConfig.endpointLiqDetailStats;
        }
        let body = JSON.stringify({ordRestoId:restoId, dates:dates, month:month}) 
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: body
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        console.log("ERROR ORDER STATS SERVICE", e)
        reject(e)
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/provider/statistics/StatsService.js